
export const PRIMARY_CONTACT_PERSON_TYPES = [
    'PC',
    'PC_DEP',
    'PC_PTF',
    'PTF',
    'PC_ITF'
];